import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { RefMouvement } from './ref-mouvement.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { OperateurInformationsDomaine } from '../../intervenant/models/operateur-informations-domaine.model';
import { Operateur } from '../../intervenant/models/operateur.model';
import { Produit } from '../../habilitation/models/produit.model';

export class PressionResultatItem {
    static jsonMap = {
        idOperateur: 'idIntervenant',
        codeProduit: 'codeProduit',
        adresse: 'adresse',
        idMouvement: 'idMouvement',
        typeMouvement: { key: 'idRefMouvement', converter: new (DataIdConverterFactory.build(RefMouvement, 'refMouvements'))() },
        dateMouvement: { key: 'dateMouvement', converter: new DateConverter() },
        estRealise: 'estRealise',
        estNonControlable: 'estNonControlable',
        numeroDossier: 'numeroDossier',
        volume: 'volume',
        numeroLot: 'numeroLot'
    };

    idOperateur: number;
    operateur: Operateur;
    infosOperateur: OperateurInformationsDomaine[] = [];

    codeProduit: string;
    produit: Produit;

    adresse: string;
    idMouvement: number;
    typeMouvement: RefMouvement;
    dateMouvement: moment.Moment;
    estRealise: boolean;
    estNonControlable: boolean;
    numeroDossier: number;
    volume: number;
    numeroLot: string;
}
